import {
  put, call, takeEvery,
} from 'redux-saga/effects';
import { DashboardService } from '../services';
import { ActionTypes } from '../constants';

async function fetchAsync(func: any, arg: any) {
  try {
    const response = arg !== null ? await func(arg) : await func();
    return response;
  } catch (error: any) {
    return {
      error: true,
      message: error.response.data.message,
      status: error.response.data.statusCode,
    };
  }
}

function* dashboardDetail(action: any): Generator {
  try {
    const data: any = yield call(fetchAsync, DashboardService.getDashboardDetails, action.payload);
    if (data.error) {
      if (data.status === 403) {
        yield put({ type: ActionTypes.LOGOUT_WITH_ERROR_REQUEST });
      } else {
        yield put({ type: ActionTypes.DASHBOARD_DATA_ERROR, payload: data.message });
      }
    } else {
      const modifiedData: any = [];
      data?.forEach((ele: any) => {
        modifiedData.push(ele.data);
      });
      yield put({ type: ActionTypes.DASHBOARD_DATA_SUCCESS, payload: modifiedData });
    }
  } catch (e: any) {
    yield put({ type: ActionTypes.DASHBOARD_DATA_ERROR, error: e.data });
  }
}

export function* watchRewardPointSaga() {
  yield takeEvery(ActionTypes.DASHBOARD_DATA_REQUEST, dashboardDetail);
}
export default watchRewardPointSaga;
